import Vue from 'vue'
import Router from 'vue-router'

import home from '@/components/main'
import orderList from '@/components/orderList'

import delivery from '@/components/delivery'
import deliveryDetail from '@/components/deliveryDetail'
import deliveryQuery from '@/components/deliveryQuery'
import material from '@/components/material'
import quality from '@/components/quality'
import sampling from '@/components/sampling'
import samplingUpdate from '@/components/samplingUpdate'
import samplingHis from '@/components/samplingHis'
import samplingDetermine from '@/components/samplingDetermine'
import samplingWeaving from '@/components/samplingWeaving'
import samplingWeavingUpdate from '@/components/samplingWeavingUpdate'
import samplingWeavingHis from '@/components/samplingWeavingHis'
import samplingWeavingDetermine from '@/components/samplingWeavingDetermine'

import orderFilter from '@/components/orderFilter'

import materialEntry from '@/components/materialEntry'

import qualityList from '@/components/qualityList'
import qualityListCJ from '@/components/qualityListCJ'
import qualityDetail from '@/components/qualityDetail'
import qualityDetailBZ from '@/components/qualityDetailBZ'
import qualityDetailBZJB from '@/components/qualityDetailBZJB'
import qualityDetailYB from '@/components/qualityDetailYB'
import weChat from '@/components/weChat'

import chgPwd from '@/components/chgPwd'
import label from '@/components/label'
import labelOrders from '@/components/labelOrders'
import test from '@/components/test'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    // {
    //   path: '/',
    //   name: 'test',
    //   component: test
    // },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList
    },
    {
      path: '/delivery',
      name: 'delivery',
      component: delivery
    },
    {
      path: '/deliveryQuery/:jsonPara',
      name: 'deliveryQuery',
      component: deliveryQuery
    },
    {
      path: '/deliveryDetail/:jsonPara',
      name: 'deliveryDetail',
      component: deliveryDetail
    },
    {
      path: '/material',
      name: 'material',
      component: material
    },
    {
      path: '/quality',
      name: 'quality',
      component: quality
    },
    {
      path: '/qualityList/:jsonPara',
      name: 'qualityList',
      component: qualityList
    },
    {
      path: '/qualityListCJ/:jsonPara',
      name: 'qualityListCJ',
      component: qualityListCJ
    },
    {
      path: '/qualityDetail/:jsonPara',
      name: 'qualityDetail',
      component: qualityDetail
    },
    // 丸编
    {
      path: '/qualityDetailBZ',
      name: 'qualityDetailBZ',
      component: qualityDetailBZ
    },
    // 经编
    {
      path: '/qualityDetailBZJB',
      name: 'qualityDetailBZJB',
      component: qualityDetailBZJB
    },
    {
      path: '/qualityDetailYB/:jsonPara',
      name: 'qualityDetailYB',
      component: qualityDetailYB
    },
    {
      path: '/sampling',
      name: 'sampling',
      component: sampling
    },
    {
      path: '/samplingUpdate/:jsonPara',
      name: 'samplingUpdate',
      component: samplingUpdate
    },
    {
      path: '/samplingHis/:jsonPara',
      name: 'samplingHis',
      component: samplingHis
    },
    {
      path: '/samplingDetermine/:jsonPara',
      name: 'samplingDetermine',
      component: samplingDetermine
    },
    {
      path: '/samplingWeaving',
      name: 'samplingWeaving',
      component: samplingWeaving
    },
    {
      path: '/samplingWeavingUpdate/:jsonPara',
      name: 'samplingWeavingUpdate',
      component: samplingWeavingUpdate
    },
    {
      path: '/samplingWeavingHis/:jsonPara',
      name: 'samplingWeavingHis',
      component: samplingWeavingHis
    },
    {
      path: '/samplingWeavingDetermine/:jsonPara',
      name: 'samplingWeavingDetermine',
      component: samplingWeavingDetermine
    },
    {
      path: '/orderFilter/:jsonPara',
      name: 'orderFilter',
      component: orderFilter
    },
    {
      path: '/materialEntry/:jsonPara',
      name: 'materialEntry',
      component: materialEntry
    },
    {
      path: '/weChat',
      name: 'weChat',
      component: weChat
    },
    {
      path: '/chgPwd',
      name: 'chgPwd',
      component: chgPwd
    },
    {
      path: '/label',
      name: 'label',
      component: label
    },
    {
      path: '/labelOrders',
      name: 'labelOrders',
      component: labelOrders
    },
    {
      path: '/yarnChange',
      name: 'yarnChange',
      component: () => import('@/components/yarnChange')
    },
    {
      path: '/yarnDetail',
      name: 'yarnDetail',
      component: () => import('@/components/yarnDetail')
    },
    {
      path: '/yarnList',
      name: 'yarnList',
      component: () => import('@/components/yarnList')
    },
    {
      path: '/yarnInfor',
      name: 'yarnInfor',
      component: () => import('@/components/yarnInfor')
    },
    {
      path: '/Inspection',
      name: 'Inspection',
      component: () => import('@/components/Inspection')
    },
    {
      path: '/Inspecinfor',
      name: 'Inspecinfor',
      component: () => import('@/components/Inspecinfor')
    },
    {
      path: '/screeningCriteria',
      name: 'screeningCriteria',
      component: () => import('@/components/screeningCriteria')
    },
    {
      path: '/scan/:id',
      name: 'scan',
      component: () => import('@/components/scan')
    },
    {
      path: '/warpingHistoryList',
      name: 'warpingHistoryList',
      component: () => import('@/components/warpingHistory/warpingHistoryList')
    },
    {
      path: '/warpingHistoryDetail',
      name: 'warpingHistoryDetail',
      component: () => import('@/components/warpingHistory/warpingHistoryDetail')
    },
    {
      path: '/warpingHistoryAct',
      name: 'warpingHistoryAct',
      component: () => import('@/components/warpingHistory/warpingHistoryAct')
    },
    {
      path: '/editHistoryList',
      name: 'editHistoryList',
      component: () => import('@/components/editHistory/editHistoryList')
    },
    {
      path: '/editHistoryDetail',
      name: 'editHistoryDetail',
      component: () => import('@/components/editHistory/editHistoryDetail')
    },
    {
      path: '/editHistoryAct',
      name: 'editHistoryAct',
      component: () => import('@/components/editHistory/editHistoryAct')
    },
    {
      path: '/weaveEnter',
      name: 'weaveEnter',
      component: () => import('@/components/WBZChange/weaveEnter')
    },
    {
      path: '/weaveChangeDetail',
      name: 'weaveChangeDetail',
      component: () => import('@/components/WBZChange/weaveChangeDetail')
    },
    {
      path: '/weaveChangeAct',
      name: 'weaveChangeAct',
      component: () => import('@/components/WBZChange/weaveChangeAct')
    },
    {
      path: '/yarnPickDetail',
      name: 'yarnPickDetail',
      component: () => import('@/components/yarnPick/yarnPickDetail')
    },
    {
      path: '/yarnPickAct',
      name: 'yarnPickAct',
      component: () => import('@/components/yarnPick/yarnPickAct')
    },
    {
      path: '/yarnLeftDetail',
      name: 'yarnLeftDetail',
      component: () => import('@/components/yarnLeft/yarnLeftDetail')
    },
    {
      path: '/yarnLeftAct',
      name: 'yarnLeftAct',
      component: () => import('@/components/yarnLeft/yarnLeftAct')
    },
    {
      path: '/yarnErrorDetail',
      name: 'yarnErrorDetail',
      component: () => import('@/components/yarnChangeError/yarnErrorDetail')
    },
    {
      path: '/yarnErrorAct',
      name: 'yarnErrorAct',
      component: () => import('@/components/yarnChangeError/yarnErrorAct')
    },
    {
      path: '/aggregatestatistics',
      name: 'aggregatestatistics',
      component: () => import('@/components/aggregatestatistics')
    },
    {
      path: '/aggregatestatisticsdetail',
      name: 'aggregatestatisticsdetail',
      component: () => import('@/components/aggregatestatisticsdetail')
    },
    {
      path: '/wbfinish',
      name: 'wbfinish',
      component: () => import('@/components/wbFinish/wbFinish')
    },
    {// 全部取消入口
      path: '/yarnOtpEnter',
      name: 'yarnOtpEnter',
      component: () => import('@/components/wbYarnDetailsCancel/yarnOtpEnter')
    },
    {// 全部取消列表
      path: '/yarnOtpAllCancel',
      name: 'yarnOtpAllCancel',
      component: () => import('@/components/wbYarnDetailsCancel/yarnOtpAllCancel')
    }, 
    {// 纱线补录入口页面
      path: '/conditionEnter',
      name: 'conditionEnter',
      component: () => import('@/components/yarnSupplement/conditionEnter')
    }, 
    {// 纱线补录入口 - 原丝品种
      path: '/yarnSupplementDetail',
      name: 'yarnSupplementDetail',
      component: () => import('@/components/yarnSupplement/yarnSupplementDetail')
    }, 
    {// 纱线补录入口 - 原丝具体操作
      path: '/yarnSupplementAct',
      name: 'yarnSupplementAct',
      component: () => import('@/components/yarnSupplement/yarnSupplementAct')
    },
    {// 纱线取消入口
      path: '/availsForCancel',
      name: 'availsForCancel',
      component: () => import('@/components/wbYarnDetailsCancel/availsForCancel')
    },
    {// 纱线取消操作页面
      path: '/yarnDetailCancel',
      name: 'yarnDetailCancel',
      component: () => import('@/components/wbYarnDetailsCancel/yarnDetailCancel')
    },
    {// 纱线调整入口
      path: '/availsForChange',
      name: 'availsForChange',
      component: () => import('@/components/wbYarnDetailsChange/availsForChange')
    },
    {// 纱线调整详情页面
      path: '/yarnDetailChange',
      name: 'yarnDetailChange',
      component: () => import('@/components/wbYarnDetailsChange/yarnDetailChange')
    },
    {// 纱线调整-挂纱调整
      path: '/yarnHangAdjust',
      name: 'yarnHangAdjust',
      component: () => import('@/components/wbYarnDetailsChange/yarnHangAdjust')
    },
    {// 纱线调整-挑纱/换纱调整
      path: '/yarnPickAdjust',
      name: 'yarnPickAdjust',
      component: () => import('@/components/wbYarnDetailsChange/yarnPickAdjust')
    },
    {// 纱线调整-卸纱调整
      path: '/yarnUnloadAdjust',
      name: 'yarnUnloadAdjust',
      component: () => import('@/components/wbYarnDetailsChange/yarnUnloadAdjust')
    },
    {// 落布卷补录入口
      path: '/supplementEnter',
      name: 'supplementEnter',
      component: () => import('@/components/rollSupplement/supplementEnter')
    },
    {// 试验反标签打印
      path: '/testquality',
      name: 'testQualityList',
      component: () => import('@/components/testQuality/testQualityList')
    },
    {// 试验反标签打印
      path: '/testqualitydetail',
      name: 'testQualityDetail',
      component: () => import('@/components/testQuality/testQualityDetail')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js